export const namespace = (_namespace = 'window.console', _parent: any = window) => {
    if (typeof _namespace === 'string' && _namespace) {
        const parts: string[] = _namespace.split('.');
        for (let i = 0, max = parts.length; i < max; i++) {
            if (!_parent[parts[i]]) _parent[parts[i]] = {};
            _parent = _parent[parts[i]];
        }
    }
    return _parent;
};

export const getUrlParam = (url: string, paramKey: string): string | undefined => {
    const paramVal = new URL(url).searchParams.get(paramKey);
    return paramVal ?? undefined;
};

export const getDefinedSearchParams = (params: Record<string, unknown>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [key, value] of Object.entries(params)) {
        if (isDefined(value)) {
            result[key] = String(value);
        }
    }

    return result;
};

export const stringifyDefinedSearchParams = (params: Record<string, unknown>): string => {
    return new URLSearchParams(getDefinedSearchParams(params)).toString();
};

export const getLocaleInfo = (locale: string = 'ko-kr'): Record<'language' | 'country', string> => {
    // e.g. 'ko-kr', 'ja-jp', 'zh-tw', ...
    const localeValues = locale.split('-');
    return {
        language: localeValues[0],
        country: localeValues[1],
    };
};

export function isDefined<T>(val: T | undefined | null): val is T {
    return !(val === null || typeof val === 'undefined');
}

export async function wait(milliseconds: number): Promise<void> {
    return new Promise((res) => {
        setTimeout(res, milliseconds);
    });
}
